export default class LogUtils {

    static isDebug = process.env.NODE_ENV === 'development';

    static jsonLog(data) {
        if (LogUtils.isDebug) {
            var parse = JSON.stringify(data);
            console.log(parse)
        }
    }

    static log(str) {
        if (this.isDebug) {
            console.log(str)
        }
    }
}